import React, {useState} from 'react';
import SideBar from '../SideBar';
import styles from './styles.module.scss';
import closeSideBar from '../../assets/menu_open-24px.svg';
import hamburger from '../../../../common/assets/hamburger-light-gray.svg';

const SideBarContainerView = () => {
  const [displaySideBar, setDisplaySideBar] = useState(false);
  const toggleSideBar = () => {
    setDisplaySideBar(!displaySideBar);
  };

  return (
    <div
      className={displaySideBar ? styles.sideBarContainerShow : styles.sideBarContainerHide}
    >
      <img
        className={styles.toggleSideBarButton}
        src={closeSideBar}
        alt="closeSideBar"
        onClick={toggleSideBar}
      />
      <img
        className={styles.hamburger}
        src={hamburger}
        alt="hamburger"
        onClick={toggleSideBar}
      />
      <SideBar/>
      <div
        className={displaySideBar ? styles.overlayOn : styles.overlayOff}
        onClick={toggleSideBar}
      >
      </div>
    </div>
  );
};

export default SideBarContainerView;


